// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"0ccee60f","171":"0941d115","606":"74d6f8a1","610":"9076fddb"}[chunkId] + ".chunk.js";
};